define.alias("shared/components/shared/mavely/links/mobile-tabs", "calendar/components/shared/mavely/links/mobile-tabs");